if (document.querySelector('.accordion')) {
  let acc = new Accordion('.accordion');
  acc.open(0);
}

// const productSwiper = new Swiper('.product-swiper', {
//   loop: true,
//   breakpoints: {
//     320: {
//       slidesPerView: 1,
//       spaceBetween: 40
//     },
//     768: {
//       slidesPerView: 1,
//       spaceBetween: 40
//     },
//   },
//   pagination: {
//     el: '.product-swiper-pagination',
//   },

//   // Navigation arrows
//   navigation: {
//     nextEl: '.product-swiper-button-next',
//     prevEl: '.product-swiper-button-prev',
//   },
// });

// Welcome-set gifts: rules come from snippets/gift-rules.liquid (bundle_selector → package → gifts → variants)
const GIFT_DEBUG = false;

const manageCart = {
  init() {
    this.cartButton = document.getElementById('addToCart');
    this.asideCart = document.getElementById('asideCart');
    this.cartAllItems = document.getElementById('cartAllItems');
    this.cartFullPrice = document.getElementById('cartFullPrice');
    this.cartFreeShipping = document.getElementById('cartFreeShipping');
    this.cartTotalDiscount = document.getElementById('cartTotalDiscount');
    // this.cartTotalFreeItem = document.getElementById('cartTotalFreeItem');
    this.cartTotalDiscountValue = document.getElementById('cartTotalDiscountValue');
    this.cartOriginalPrice = document.getElementById('cartOriginalPrice');
    this.cartItemsList = document.getElementById('cartItemsList');
    this.cartButtonMain = document.getElementById("product_main_button");
    this.cartButtonMainPrice = document.getElementById('product_main_button_price');
    this.cartOtherProductCarousel = document.getElementById('other_products_cart');
    this.bonusFirst = document.querySelector('.bonus-1');
    this.cartBusy = false;
    this.combineProduct = document.getElementById('combineProducts');

    this.variantInputs = document.querySelectorAll('.variant_label input');

    const checkedInput = document.querySelector('.variant_label input:checked');
    if (checkedInput) {
      this.updateVariant.call(this, checkedInput);
    }

    this.addEventListeners();
    this.updateCartDisplay();
  },

  updateVariant(input) {
    const label = input.closest('.variant_label');
    const variantPrice = input.dataset.variantPrice;
    this.cartButtonMain.dataset.quantity = label.dataset.cartQuantity;
    this.cartButtonMainPrice.textContent = ' - ' + variantPrice;
  },

  addEventListeners() {
    if (this.cartButton) {
      this.cartButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.addToCart(this.cartButton);
      });
    }

    this.variantInputs.forEach(input => {
      input.addEventListener('change', () => this.updateVariant.call(this, input));
    });

    document.querySelectorAll('.addOtherToCart').forEach(button => {
      button.onclick = (event) => {
        event.preventDefault();
        const variantId = button.dataset.variantId;
        const quantity = parseInt(button.dataset.quantity || '1', 10);
        if (variantId) {
          this.addToCart(button, { id: variantId, quantity });
        } else {
          console.error('Missing data-variant-id on .addOtherToCart button');
        }
      };
    });

    if (this.asideCart) {
      document.body.addEventListener('click', (event) => {
        if (event.target.classList.contains('close-cart')) {
          document.body.classList.remove("overflow-hidden");
          this.toggleCart(false);
        } else if (event.target.classList.contains('open-cart')) {
          this.toggleCart(true);
          document.body.classList.add("overflow-hidden");
        } else if (
          event.target.classList.contains('cart-item--remove') ||
          event.target.classList.contains('cart-item--add') ||
          event.target.classList.contains('cart-item--sub')
        ) {
          this.handleQuantityChange(event);
        }
      });
    }
  },

  async addToCart(button = null, customProduct = null) {
    button?.classList.add('button--loading');
    try {
      let response;
      if (customProduct) {
        response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(customProduct),
        });
      } else {
        const addToCartForm = document.querySelector('form[action$="/cart/add"]');
        const formData = new FormData(addToCartForm);
        response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: formData,
        });
      }
      if (!response.ok) throw new Error('Add to cart failed');
      await this.updateCartDisplay(true);
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      button?.classList.remove('button--loading');
    }
  },

  async updateCartDisplay(openCart = false) {
    
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      let data = await response.json();
      data = await this.syncGiftLineItems(data);
      this.lastCartCount = data.item_count;
      this.updateCartUI(data);
      this.reloadCarousel(data);
      if (openCart) {
        document.body.classList.add("overflow-hidden");
        this.toggleCart(true);
      }
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  },

  reloadCarousel(cart) {
    const cartHandles = cart.items.map(item => item.handle);
    const slides = document.querySelectorAll('#other_products_cart .splide__slide');
    slides.forEach(slide => {
      const handle = slide.querySelector('a')?.getAttribute('href')?.split('/').pop();
      if (!handle) return;
      if (cartHandles.includes(handle)) {
        slide.style.display = 'none';
      } else {
        slide.style.display = 'block';
      }
    });
    const visibleSlides = Array.from(slides).filter(slide => slide.style.display !== 'none');
    const carousel = document.getElementById('other_products_cart');
    if (carousel) {
      carousel.style.display = visibleSlides.length > 0 ? 'block' : 'none';
    }
    if (window.otherProductsSplide) {
      window.otherProductsSplide.refresh();
    }
  },

  getGiftRules() {
    if (this.giftRules) return this.giftRules;
    try {
      const el = document.getElementById('giftRules');
      this.giftRules = el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      console.error('[gifts] invalid giftRules JSON', e);
      this.giftRules = {};
    }
    return this.giftRules;
  },

  // Keeps first-order gifts in the cart: a product has gift tiers (e.g. 1 piece → bottle, 3 pieces → welcome set);
  // for every tier with >= tier.min pieces its gift variants are added once
  // (a variant shared by several products or tiers, e.g. the bottle, only once).
  // Gift variants that no longer qualify are removed.
  async syncGiftLineItems(cart) {
    const rules = this.getGiftRules();
    const ruleEntries = [];
    for (const [pid, rule] of Object.entries(rules)) {
      (Array.isArray(rule) ? rule : [rule]).forEach((tier) => ruleEntries.push([pid, tier]));
    }
    if (!ruleEntries.length) return cart;

    const giftVariantIds = new Set();
    for (const [, rule] of ruleEntries) {
      (rule.gifts || []).forEach((vid) => giftVariantIds.add(Number(vid)));
    }

    const qtyByProduct = {};
    for (const item of cart.items) {
      if (giftVariantIds.has(Number(item.variant_id))) continue;
      const pid = Number(item.product_id);
      qtyByProduct[pid] = (qtyByProduct[pid] || 0) + item.quantity;
    }

    const desiredQty = {};
    for (const vid of giftVariantIds) desiredQty[vid] = 0;
    for (const [pid, rule] of ruleEntries) {
      if ((qtyByProduct[Number(pid)] || 0) < (rule.min || 1)) continue;
      (rule.gifts || []).forEach((vid) => { desiredQty[Number(vid)] = 1; });
    }

    const linesByGift = {};
    for (const item of cart.items) {
      const vid = Number(item.variant_id);
      if (!giftVariantIds.has(vid)) continue;
      (linesByGift[vid] = linesByGift[vid] || []).push({ key: item.key, quantity: item.quantity });
    }

    const updates = {};
    const itemsToAdd = [];
    for (const vid of giftVariantIds) {
      const desired = desiredQty[vid] || 0;
      const lines = linesByGift[vid] || [];
      if (!lines.length) {
        if (desired > 0) itemsToAdd.push({ id: vid, quantity: desired });
        continue;
      }
      lines.forEach((line, i) => {
        const target = i === 0 ? desired : 0;
        if (line.quantity !== target) updates[line.key] = target;
      });
    }

    const hasUpdates = Object.keys(updates).length > 0;
    const hasAdds = itemsToAdd.length > 0;

    if (GIFT_DEBUG) {
      console.log('[gifts] qtyByProduct', qtyByProduct, 'desired', desiredQty);
      console.log('[gifts] updates', updates, 'adds', itemsToAdd);
    }

    if (!hasUpdates && !hasAdds) return cart;

    const root = window.Shopify.routes.root;
    try {
      if (hasUpdates) {
        const r = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });
        if (!r.ok) console.error('[gifts] update.js', r.status, await r.text());
      }
      if (hasAdds) {
        const r = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd }),
        });
        if (!r.ok) console.error('[gifts] add.js', r.status, await r.text());
      }
      const r2 = await fetch(`${root}cart.js`);
      if (!r2.ok) return cart;
      return await r2.json();
    } catch (e) {
      console.error('Gift sync failed:', e);
      return cart;
    }
  },

  updateCartUI(data) {

    let isOnlyAccesorry = true;
    let dataTotalPrice = (data.total_price / 100);
    let decimalPrice = (data.total_price / 100).toLocaleString("cs-CZ", { minimumFractionDigits: 0 });
    let originalPrice = (data.original_total_price / 100).toLocaleString("cs-CZ", { minimumFractionDigits: 0 });
    let totalDiscount = (data.total_discount / 100).toLocaleString("cs-CZ", { minimumFractionDigits: 0 });
    let itemsCount = 0;

    data.items.forEach(element => {
      if (element.handle != 'odmerka' && element.handle != 'sample-kit' && element.original_price > 0) {
        isOnlyAccesorry = false;
        itemsCount += element.quantity;
      }
    });

    if (this.combineProduct) {
      this.combineProduct.classList.toggle('hidden', itemsCount < 1);
    }

    if (isOnlyAccesorry) {
      this.bonusFirst.classList.add('not-possible');
    } else {
      this.bonusFirst.classList.remove('not-possible');
    }

    // if (totalDiscount < 1 || itemsCount > 3) {
    //   this.cartTotalDiscount.classList.add('hidden');
    // } else {
    //   this.cartTotalDiscount.classList.remove('hidden');
    // }

    this.cartOtherProductCarousel?.classList.toggle('hidden', itemsCount < 1);
    totalDiscount > 1 ? this.cartTotalDiscount.classList.remove('hidden') : this.cartTotalDiscount.classList.add('hidden');
    // totalDiscount > 1 ? this.cartTotalFreeItem.classList.remove('hidden') : this.cartTotalFreeItem.classList.add('hidden');
    totalDiscount < 1 ? this.cartOriginalPrice.classList.add('hidden') : this.cartOriginalPrice.classList.remove('hidden');

    // Same rule as the Shopify automatic discount "Doprava zdarma": at least FREE_SHIPPING_MIN_QTY paid items in the cart
    const paidQty = data.items.reduce((sum, item) => sum + (item.original_price > 0 ? item.quantity : 0), 0);
    this.cartFreeShipping.classList.toggle('hidden', paidQty < window.FREE_SHIPPING_MIN_QTY);
    const currency = data.currency === 'EUR' ? '€' : data.currency;
    this.cartTotalDiscountValue.textContent = `${totalDiscount} ${currency}`;
    // this.cartOriginalPrice.textContent = `${originalPrice} ${data.currency.toUpperCase()}`;
    this.cartOriginalPrice.textContent = `${originalPrice} ${currency}`;
    this.cartFullPrice.textContent = `${decimalPrice} ${currency}`;
    this.cartAllItems.textContent = data.item_count;
    this.setCartIcon(data.item_count);
    this.changeProgresLine(itemsCount);
  },

  setCartIcon(count) {
    const cartCount = document.getElementById("cartIconCount");
    const cartButton = document.getElementById("checkoutButton");
    cartCount.textContent = count;
    cartCount.classList.toggle('hide', count === 0);
    cartButton.classList.toggle('deactivated', count === 0);
  },

  changeProgresLine(count) {
    const progressCart = document.getElementById('progressCart');
    if (count > 6) {
      progressCart.dataset.count = 'max';
    }
    if (count <= 6) {
      progressCart.dataset.count = count;
    }
  },

  toggleCart(show) {
    this.asideCart.classList.toggle('opened', show);
    if (show) this.refetchCartItems();
  },

  async refetchCartItems() {
    try {
      // right after the gift sync Shopify can still render the previous cart, so retry until the item count matches cart.js
      let html = '';
      for (let attempt = 0; attempt < 5; attempt++) {
        if (attempt) await new Promise((resolve) => setTimeout(resolve, 400));
        const response = await fetch(`/?sections=custom-cart-items&t=${Date.now()}`);
        const data = await response.json();
        html = data['custom-cart-items'].trim();
        const synced = html.match(/data-cart-sync="(\d+)"/);
        if (this.lastCartCount == null || !synced || Number(synced[1]) === this.lastCartCount) break;
      }
      this.cartItemsList.innerHTML = html;
    } catch (error) {
      console.error('Error refetching cart items:', error);
    }
  },

  handleQuantityChange(event) {
    if (this.cartBusy) return;
    this.cartBusy = true;
    event.target.classList.add('cart-item--spinner');
    const itemId = event.target.getAttribute('key');
    const itemValue = event.target.getAttribute('data-val') || 0;
    this.changeQuantity(itemId, itemValue);
  },

  async changeQuantity(id, qty) {
    const updates = { [id]: qty };
    try {
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      await this.updateCartDisplay(this.asideCart.classList.contains('opened'));
    } catch (error) {
      console.error('Error updating cart quantity:', error);
    } finally {
      this.cartBusy = false;
    }
  },
};

// Initialize the cart on page load
document.addEventListener('DOMContentLoaded', () => manageCart.init());
// let mainNavigation = {
//   init: function() {
//     let userButton = document.getElementById('userButton');
//     let loginPopup = document.getElementById('loginPopup')

//     userButton.addEventListener('click', function(){
//       loginPopup.classList.toggle('hidden');
//     })
//   }
// }

const mobileNavigation = { 
  init: function() {
    const toggleNav = document.getElementById('toggleNav');
    const navMobile = document.getElementById('navMobile');
    document.getElementById('toggleNav').addEventListener('click', function() {
      toggleNav.classList.toggle('is-active');
      navMobile.classList.toggle('is-active');
      document.body.classList.toggle("overflow-hidden");
    })
  }
}

let popups = {
  init: function () {
    const ingredientsPopup = document.getElementById('product-ingredients-popup');
    const ingredientsPopups = document.querySelectorAll('.product-extra-info-ac a');
    const ingredientsPopupAll = document.getElementById('product-ingredients-popup-all');
    const ingredientsPopupConent = document.getElementById('product-ingredients-popup-content');
    const preparePopup = document.getElementById('product-prepare-popup');
    const preparePopupConent = document.getElementById('product-prepare-popup-content');
    const closePopup = document.getElementById('popup-close');

    if (preparePopup) {
      preparePopup.addEventListener('click', () => {
        Swal.fire({
          html: preparePopupConent.innerHTML,
          showConfirmButton: false,
          width: "1220",
          showCloseButton: true,
          showClass: {
            popup: `
                    animate__animated
                    animate__fadeInUp
                    animate__faster
                  `
          },
          hideClass: {
            popup: `
                    animate__animated
                    animate__fadeOutDown
                    animate__faster
                  `
          }
        });
      })
    }

    const openIngredientsPopup = () => {
      Swal.fire({
        html: ingredientsPopupConent.innerHTML,
        showConfirmButton: false,
        width: "1320px",
        showCloseButton: true,
        showClass: {
          popup: `
                    animate__animated
                    animate__fadeInUp
                    animate__faster
                  `
        },
        hideClass: {
          popup: `
                    animate__animated
                    animate__fadeOutDown
                    animate__faster
                  `
        }
      });
    }

    if( ingredientsPopups.length > 0) {
      ingredientsPopups.forEach(element => {

        if( element.getAttribute('href') === "#open-popup") {
          element.addEventListener('click', (e) => {
              e.preventDefault(); 
              openIngredientsPopup();
            })
        }
      });
    }

    if (ingredientsPopup) {
      ingredientsPopup.addEventListener('click', () => openIngredientsPopup())
    }
    if (ingredientsPopupAll) {
      ingredientsPopupAll.addEventListener('click', () => openIngredientsPopup())
    }
  }
}


addEventListener("load", (event) => {
  manageCart.init();
  popups.init();
  mobileNavigation.init();
});

let isScrolled = false;
let isProductBarVisible = false;
const productBar = document.getElementById('header_products_bar');
gsap.registerPlugin(ScrollTrigger);
window.addEventListener("scroll", () => {
  // if (window.scrollY > 700 && !isScrolled) {
  //   isScrolled = true;
  //   gsap.to(".product-button", { backgroundColor: "#17392b", color: "#fff", duration: 0.5,"--product-button-after": "#ffffff" });
  // } else if (window.scrollY <= 700 && isScrolled) {
  //   isScrolled = false;
  //   gsap.to(".product-button", { backgroundColor: "#fdfcfb", color: "#17392b", duration: 0.5, "--product-button-after": "#17392b" });
  // }


    const productDetailSection = document.querySelector('.product-detail');
    const scrollOffset = 300;
    if( productDetailSection) {
      const scrollDistance = productDetailSection.offsetTop + productDetailSection.offsetHeight - scrollOffset;
      if (window.scrollY > scrollDistance && !isProductBarVisible) {
        isProductBarVisible = true;
        productBar?.classList.remove('hidden');
        // gsap.to(".product-button", { backgroundColor: "#17392b", color: "#fff", duration: 0.5,"--product-button-after": "#ffffff" });
      } else if (window.scrollY <= scrollDistance && isProductBarVisible) {
        isProductBarVisible = false;
        productBar?.classList.add('hidden');
        // gsap.to(".product-button", { backgroundColor: "#fdfcfb", color: "#17392b", duration: 0.5, "--product-button-after": "#17392b" });
      }
    }
    

});

const headerProductsOptionsClose = document.getElementById('header-products-options-close');
const headerProductsCheckbox = document.getElementById('header_products_checkbox');

headerProductsOptionsClose?.addEventListener('click', () => {
  headerProductsCheckbox.checked = false;
});

document.addEventListener("DOMContentLoaded", function() {
  if (window.location.hash === "#reviews") {
    gsap.to(window, { 
      duration: 1.2,
      delay: 0.5,
      scrollTo: { y: "#recenzie", offsetY:50 },
      onComplete: function() {
        // Remove the hash from the URL
        history.replaceState(null, null, window.location.pathname);
      } 
    });
  }
});

const scrollToButtons = document.querySelectorAll('.scroll-to-section');
scrollToButtons.forEach(element => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
    const scrollToId = element.getAttribute('href').replace("#", "");
    const scrollSection = document.getElementById( scrollToId );
    if( scrollSection ) {
      gsap.to(window, { 
      duration: 1.2,
      scrollTo: { y: scrollSection, offsetY:80 },
      onComplete: function() {
        // Remove the hash from the URL
        history.replaceState(null, null, window.location.pathname);
      } 
    });
    }
  })
});

const parentDiv = document.querySelector('.section.reviews');
if( parentDiv ) {
  parentDiv.addEventListener('click', function(event) {
    if (event.target && event.target.matches('.jdgm-rev__pic-img')) {
      event.target.classList.add('hidden');
      setTimeout(() => {
        event.target.classList.remove('hidden');
        window.dispatchEvent(new Event('resize'));
      }, 100);
    }
  });
}

const flashMessage = document.getElementById('flash-message');
const flashToggle = document.getElementById('flash-toggle');
document.addEventListener("DOMContentLoaded", function() {
  checkFlashMessageVisibility();
});

const checkFlashMessageVisibility = () => {
  if ( flashToggle && sessionStorage.getItem('flashMessage') != 'false' ) {
    flashMessage.classList.add('flash-visible');
  }
}

if(flashToggle) {
  flashToggle.addEventListener('click', function() {
    flashMessage.classList.remove('flash-visible');
    sessionStorage.setItem('flashMessage', 'false');
  })
}

